// @ts-nocheck
import axios from 'axios';
import TagManager from 'react-gtm-module';

import { Helpers } from '@shared/utils/Helpers';
import Language from '@shared/config/constants/Language';
import { LogService } from '@shared/services/LogService';
import { decryptAffiliate } from '@shared/api/decryptAffiliate';
import { setAlert } from '@shared/store/slices/alert.actions';
import Config from '@shared/config/constants/config-main';
import { PAYMENT_GATEWAYS } from '@entities/payment-plan';

import * as Sub from '@entities/subscription/store/subscription.actions';

const API_URL = Config.API_URL;

export {
  changePaymentMethod,
  formWasSubmitted,
  formResultRetrieved,
  formResetComplete,
  gpayReceivedd,
  gpayLoaded,
} from '@entities/subscription/store/subscription.actions';

const buildPapData = async () => {
  const papData: Record<string, string> = {};
  const papData1 = Helpers.getUrlParameter('data1') || '';
  const papData2 = Helpers.getUrlParameter('data2') || '';
  const papData3 = Helpers.getUrlParameter('data3') || '';
  let a_aid = Helpers.getUrlParameter('a_aid') || '';

  if (a_aid) {
    const decrypted = await decryptAffiliate(a_aid);
    if (decrypted) a_aid = decrypted;
  }

  if (papData1) papData.data1 = papData1;
  if (papData2) papData.data2 = papData2;
  if (papData3) papData.data3 = papData3;
  if (a_aid) papData.affiliateId = a_aid;

  return { papData, a_aid };
};

export const subscribeUsingCard = async (formData, history, isTrial = false) => {
  const isAr = formData.language === 'ar';
  const invalid_card_details = isAr ? Language.ar_invalid_cars : Language.en_invalid_cars;
  const email_already_subscribed = isAr
    ? Language.ar_email_subscribed
    : Language.en_email_subscribed;

  formData.affiliate = '360VUZ';
  formData.utmSource = null;
  formData.utmMedium = null;
  formData.utmChannel = null;
  formData.urlReferrer = window.location.href;
  formData.adUrlReferrer = document.referrer || '';

  const config = Helpers.getAxiosHeadersConfig();

  try {
    const response = await axios.post(
      `${API_URL}/api/cc/${isTrial ? 'subscribeTrial' : 'subscribe'}`,
      formData,
      config
    );

    if (response.data && response.data.data.status && response.data.data.status === 'Pending') {
      window.location = response.data.data._links.redirect.href;
      return;
    }

    if (response.data.data.errorCode !== 0 && response.data.data.errorCode) {
      if (response.data.data.errorSource === 'Checkout') {
        await setAlert(invalid_card_details, 'danger');
      } else if (
        response.data.message === 'This email is already subscribed' ||
        response.data.message === 'This email  is already subscribed'
      ) {
        await setAlert(email_already_subscribed, 'danger');
      } else {
        await setAlert(`${response.data.message}`, 'danger');
      }

      if (formData.payment_source === 'google-pay') {
        LogService.ccSetGooglePayPayment({ email: formData.email, state: 'msisdn' });
      } else if (formData.payment_source === 'apple-pay') {
        LogService.ccSetApplePayPayment({ email: formData.email, state: 'msisdn' });
      } else if (formData.payment_source === 'paypal') {
        LogService.paypal({ email: formData.email, state: 'msisdn' });
      } else {
        LogService.clickButtonSubscribe({ email: formData.email, state: 'msisdn' });
      }
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: 'subscribe',
          eventCategory: 'CC',
          eventAction: 'subscribe',
          eventValue: '24',
          subscription_plan: formData.subscriptionOption,
          revenue: formData.subscriptionOption === 'MONTHLY' ? '$8' : '$24',
          currency: 'AED',
          page_version: formData.isWhite === true ? 'Light' : 'Dark',
        },
        dataLayerName: 'SubscriptionDataLayer',
      };
      TagManager.dataLayer(tagManagerArgs);

      const pathname = formData.isV4 ? '/cc/4/welcome' : '/cc/welcome';

      try {
        if (localStorage) {
          localStorage.setItem('isPromoValid', 'false');
          localStorage.setItem('appliedPromocode', '');
        }
      } catch (err) {}

      const orderId = response.data?.data?.orderId || null;
      const { papData, a_aid } = await buildPapData();
      const pageLink = window.location.href;

      if (pageLink.includes('/cc') && a_aid) {
        window.papCCtrialAction(orderId, papData);
      }

      const userProperties = {
        state: 'subscriber',
        subscriberId: response.data?.data?.subscriberId,
      };

      if (formData.payment_source === 'google-pay') {
        LogService.ccSetGooglePayPayment(userProperties, PAYMENT_GATEWAYS.STRIPE, true, true);
      } else if (formData.payment_source === 'apple-pay') {
        LogService.ccSetApplePayPayment(userProperties, PAYMENT_GATEWAYS.STRIPE, true, true);
      } else if (formData.payment_source === 'paypal') {
        LogService.ccClickButtonPaypalContinue();
      } else {
        LogService.clickButtonSubscribe(userProperties, true, true);
      }

      if (
        !window.location.href.includes('noredirect') &&
        formData.email !== 'cctestx@360mea.com'
      ) {
        history.push({
          pathname,
          state: {
            activationURL: response.data.data.activationURL,
            isWhite: formData.isWhite,
          },
        });
      }
    }
  } catch (err) {
    console.log(err);
    await setAlert('Error while processing payment. Please contact support', 'danger');

    if (formData.payment_source === 'google-pay') {
      LogService.ccSetGooglePayPayment();
    } else if (formData.payment_source === 'apple-pay') {
      LogService.ccSetApplePayPayment();
    } else if (formData.payment_source === 'paypal') {
      LogService.paypal();
    } else {
      LogService.clickButtonSubscribe();
    }
  }

  Sub.writeSubscriptionBtnLoading(false);
};

export const unsubscribe = async (formData) => {
  Sub.formWasSubmitted();
  const config = Helpers.getAxiosHeadersConfig();

  try {
    const res = await axios.post(`${API_URL}/api/cc/unsubscribeCC`, formData, config);

    if ((res.data.errorCode !== 0 && res.data.errorCode) || res.data.statusCode !== 200) {
      await setAlert(`${res.data.message}`, 'danger');
    } else {
      await setAlert(`${res.data.message}`, 'success');
      Sub.writeSubscriptionCcUnsubscribeSuccess();
    }
  } catch (err) {
    console.log(err);
    await setAlert('Error while unsubscribing. Please contact support', 'danger');
  }

  Sub.writeSubscriptionBtnLoading(false);
};

export const dcbUnsubscribe = async (formData, isOTPFlow = false) => {
  Sub.writeSubscriptionBtnLoading(true);
  const config = Helpers.getAxiosHeadersConfig();

  try {
    const res = await axios.post(`${API_URL}/mobile/unsubscribe`, formData, config);

    if (res.data.statusCode !== 200) {
      await setAlert(`${res.data.message}`, 'danger');
    } else {
      if (!isOTPFlow) {
        await setAlert(`${res.data.message}`, 'success');
      }
      Sub.writeSubscriptionDcbUnsubscribeSuccess(res.data?.data || {});
    }
  } catch (err) {
    console.log(err);
    await setAlert('Error while unsubscribing. Please contact support', 'danger');
  }

  Sub.writeSubscriptionBtnLoading(false);
};

export const initiatePaypalPayment = async (formData) => {
  const configHeaders = { headers: { 'Content-Type': 'application/json' } };
  const handleInitiatePaypalPaymentUrl = `${API_URL}/api/paypal/initiatePaypalPayment`;

  formData.urlReferrer = window.location.href;
  formData.adUrlReferrer = document.referrer || '';

  Sub.writeSubscriptionBtnLoading(true);

  try {
    const res = await axios.post(handleInitiatePaypalPaymentUrl, formData, configHeaders);
    const resData = res.data;

    if (resData.status === 'Pending') {
      const { papData } = await buildPapData();
      console.log('paypal pap data', papData);

      LogService.ccClickButtonPaypalContinue({ redirectUrl: resData._links.redirect.href });

      window.location.href = resData._links.redirect.href;
    } else {
      await setAlert('Error while contacting Paypal', 'danger');
      Sub.writeSubscriptionBtnLoading(false);
    }
  } catch (err) {
    console.log(err);
    await setAlert('Error while contacting Paypal', 'danger');
    Sub.writeSubscriptionBtnLoading(false);
  }
};
